module.exports = __webpack_public_path__ + "img/1519553742.5b19ac19.jpg";